import { AuthenticatedAPI } from '../../core-apis/src/apis/config/api/authenticatedApi'

const GLOBAL_APIS_URL = process.env.GLOBAL_APIS_URL ?? ''
const ORG_API_KEY = process.env.ORG_API_KEY ?? ''

class GlobalAPI extends AuthenticatedAPI {
  constructor() {
    super({
      domain: GLOBAL_APIS_URL,
      apiKey: `Bearer ${ORG_API_KEY}`,
      useInterceptors: false
    })
  }
}

export const globalAPI = new GlobalAPI()
